import React, { useContext } from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ButtonTextIcon from '../../components/buttons/ButtonTextIcon';
import { ModalContext } from '../../components/modals/Report';
import ModalEnum from '../../components/modals/Report/enums/ModalEnum';

export default function CreateReport() {
  const { handleModal } = useContext(ModalContext);

  const styles = {
    button: {
      color: 'black',
    },
  };

  return (
    <ButtonTextIcon
      variant="contained"
      color="primary"
      sx={styles.button}
      disableElevation
      icon={<InsertDriveFileIcon />}
      onClick={() => handleModal(ModalEnum.REPORTS_CREATE_NEW_REPORT_MODAL)}
    >
      Create Report
    </ButtonTextIcon>
  );
}
